import {Configuration} from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID || "a3470923-b36f-4bec-9dbd-3fbd76e7aab7";
const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID || "fca31688-8f50-4965-9634-13e2c81c0be5";
const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE ||
    "api://a039ed68-f792-440c-a63c-68d4190804f0/backoffice.access";

export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: window.location.origin
    },
    cache: {
        // Do not persist bearer tokens after the browser session ends.
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

/** Scopes requested during interactive sign-in. */
export const loginRequest = {
    scopes: ['openid', 'profile', 'email', apiScope]
};

/** The delegated scope of Outletstocks Backoffice API Prod. */
export const backofficeApiRequest = {
    scopes: [apiScope]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
